import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import './styles/01-design-system.css'
import './styles/02-ai-pages.css'
import './styles/03-components-v2.css'
import './styles/04-visual-utils.css'
import './styles/05-visual-refresh.css'
import './styles/06-polish-pass.css'
import './styles/07-refine-layer.css'
import './styles/08-consistency.css'
import './styles/08-scrollbar-and-transitions.css'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.mount('#app')
